<template lang="pug">
div(class="container")
  div(class="card")
    header(class="card-header")
      p(class="card-header-title") Tags
    div(class="card-content")
      b-error(v-if="error" :error="error" class="error")
      div(class="content")
        nx-table(
          ref="nxTable"
          urlAdd="tag/add"
          urlEdit="tag/edit"
          urlFetch="tag/list"
          urlDelete="tag/delete"
          :selectedColumns="selectedColumns"
          :checkable="true"
          @fillEdit="fill($event)"
        )
          template(#column-selector="row") {{ row.selector.name }}
          template(#form="props")
            div(class="modal-card" style="width: auto")
              header(class="modal-card-head")
                p(class="modal-card-title") {{ props.modeAdd ? 'Add tag' : 'Edit tag' }}
              section(class="modal-card-body")
                b-field(label="Selector")
                  b-select(
                    v-model="formData.selectorId"
                    placeholder="Selector"
                    required
                  )
                    option(
                      v-for="selector in selectors"
                      :key="selector._id"
                      :value="selector._id") {{ selector.name }}

                b-field(label="Name")
                  b-input(
                    v-model="formData.name"
                    type="string"
                    placeholder="Name"
                    required
                  )

              footer(class="modal-card-foot")
                b-button(
                  label="Close"
                  icon-left="close"
                  @click="$refs.nxTable.close()"
                )
                b-button(
                  label="Save"
                  icon-left="plus"
                  type="is-primary"
                  @click="$refs.nxTable.save(formData)"
                )
                b-message(v-if="props.error" title="error") {{ props.error }}

    footer(class="card-footer")
</template>

<script>
import nxTable from '@nx-t/vue-components/vue2/nxTableOld';
import bError from '@nx-t/vue-components/vue2/bError';

export default {
  components: {
    nxTable,
    bError,
  },
  data() {
    return {
      selectedColumns: ['name', 'selector'],
      selectors: '',
      formData: {
        selectorID: null,
        name: '',
      },
      error: null,
    };
  },
  created() {
    this.fetchSelectors();
  },
  methods: {
    async fetchSelectors() {
      this.selectors = null;
      this.error = null;

      try {
        const response = await fetch('selector/list');
        if (!response.ok) {
          const errorData = await response.json();
          throw errorData || { message: 'Unknown Error', status: response.status };
        }

        const data = await response.json();
        this.columns = [];
        this.selectors = data.list;
      } catch (e) {
        this.error = e?.message || e?.toString() || 'Unknown Error';
      }
    },
    fill(editData) {
      this.formData = editData;
      this.formData.selectorId = editData.selector._id;
    },
  },
};

</script>
